<template>
  <v-container fluid class="company-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab
            :href="`#tab-account`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-heart-box</v-icon>
            Company
          </v-tab>
          <v-tab
            :href="`#tab-options`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-account-cog</v-icon>
            Options
          </v-tab>
          <v-tab
            :href="`#tab-settings`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-cog</v-icon>
            Settings
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-photo`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            Photo
          </v-tab>
          <v-tab-item
            :value="'tab-account'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Edit Company</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'companycode')"
                        v-bind:value="initvalue.companycode"
                        placeholder="Company Code"
                        persistent-hint
                        single-line hint="Enter the company code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'companyname')"
                        v-bind:value="initvalue.companyname"
                        placeholder="Company Name"
                        persistent-hint
                        single-line hint="Enter the company name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=companytypes
                        :value="initvalue.companytype"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'companytype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the company type">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'companiestatus')"
                          v-bind:label="initvalue.companiestatus"
                          v-model="initvalue.companiestatus"
                          value="Active"
                      ></v-switch>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/company/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editCompany()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
            :value="'tab-options'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row class="no-gutters">
                  <v-col cols="12" md="6"><p class="text-h5">Edit Options</p></v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-form>
                       <v-select
                        class="mb-4"
                        outlined
                        dense
                        persistent-hint
                        placeholder="Sales Pricelist"
                        single-line hint="Please choose the sales pricelist"
                        :items="pricelists.length>0 ? pricelists.map(x => {
                            return {text: x.pricelistname, value: x._id};
                          }) : []"
                        v-bind:value="edit_company.options ? edit_company.options.sales_pricelistid : null"
                        v-on:change="onChangeOptions($event, 'sales_pricelistid')"
                        v-bind:error="errorindex == 20"
                      >
                      </v-select>
                      <v-select
                        class="mb-4"
                        outlined
                        dense
                        persistent-hint
                        placeholder="Online Pricelist"
                        single-line hint="Please choose the online pricelist"
                        :items="pricelists.length>0 ? pricelists.map(x => {
                            return {text: x.pricelistname, value: x._id};
                          }) : []"
                        v-bind:value="edit_company.options ? edit_company.options.online_pricelistid : null"
                        v-on:change="onChangeOptions($event, 'online_pricelistid')"
                        v-bind:error="errorindex == 20"
                      >
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-form>
                      <v-row class="nogutters">
                        <v-col cols="12" md="4">
                          <v-text-field
                            type="number"
                            class="mb-4"
                            outlined
                            dense
                            v-on:change="onChangeOptions($event, 'PrimaryDecimalPlaces')"
                            v-bind:value="edit_company.options ? edit_company.options.PrimaryDecimalPlaces : null"
                            placeholder="Primary Digits"
                            persistent-hint
                            single-line hint="Primary">
                          </v-text-field>
                          <v-text-field
                            type="number"
                            outlined
                            dense
                            v-on:change="onChangeOptions($event, 'TaxRate')"
                            v-bind:value="edit_company.options ? edit_company.options.TaxRate : null"
                            placeholder="Tax Rate"
                            persistent-hint
                            single-line hint="Tax Rate">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-text-field
                            type="number"
                            outlined
                            dense
                            v-on:change="onChangeOptions($event, 'SecondaryDecimalPlaces')"
                            v-bind:value="edit_company.options ? edit_company.options.SecondaryDecimalPlaces : null"
                            placeholder="Secondary Digits"
                            persistent-hint
                            single-line hint="Secondary">
                          </v-text-field>

                        </v-col>
                        <v-col cols="12" md="3" style="margin-top: -10px;">
                          <v-switch
                              color="primary"
                              v-on:change="onChangeOptions($event, 'isDualCurrency')"
                              v-model="edit_company.options.isDualCurrency"
                              v-bind:value="edit_company.options && edit_company.options.isDualCurrency!=null ? edit_company.options.isDualCurrency : false"
                              hint="Dual Currency"
                              :false-value="false"
                              persistent-hint>
                          </v-switch>
                          <v-switch
                              color="primary"
                              v-on:change="onChangeOptions($event, 'isSalesTax')"
                              v-model="edit_company.options.isSalesTax"
                              v-bind:value="edit_company.options ? edit_company.options.isSalesTax : false"
                              hint="Sales Tax"
                              :false-value="false"
                              persistent-hint>
                          </v-switch>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                        <v-btn
                            to="/company/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editCompanyOptions()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-settings'">
            <CompanySettings :id="initvalue._id" :data="initvalue.settings" />
          </v-tab-item>
          <v-tab-item
              :value="'tab-photo'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>

                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Upload Photo</p>
                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/company/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPhoto()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import router from '@/Routes';
import {mapActions, mapState} from "vuex";
import CompanySettings from '../Components/CompanySettings.vue';

export default {
  data () {
    return {
      company: {},
      detail: {},
      photo: {},      
      change_options: {},
      initvalue: {},
      imageurl: undefined,
      images: [],
      pricelists: [],
      upload: {},
      companytypes: ['Distributor', 'Manufacturer', 'Retail', 'Trading', 'Wholesale', 'Other Company'],
      errorindex: null,
    }
  },
  components: {
    CompanySettings,
  },
  computed: {
    ...mapState('Company', ['isReceiving']),
  },
  methods: {
    ...mapActions('Company', ['updateCompanyRequest', 'updateCompanyImageRequest', 'updateCompanyOptionsRequest','getCompaniesRequest']),
    ...mapActions('PriceList', ['getPriceListsByIdRequest']),
    editCompany() {
      this.company._id = this.initvalue._id;
      this.updateCompanyRequest(this.company);
      this.getCompaniesRequest();
      router.push('/company/list');
    },
    async editCompanyOptions() {
      this.change_options._id = this.initvalue._id;
      await this.updateCompanyOptionsRequest(this.change_options);
      router.push('/company/list');
    },
    editPhoto() {
      this.photo._id = this.initvalue._id;
      this.updateCompanyImageRequest(this.photo);
      this.getCompaniesRequest();
      router.push('/company/list');
    },
    updateChangedValue(value, field){
      this.company[field] = value;
    },
    updateChangedDetail(value, field){
      this.detail[field] = value;
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.photo.companyimage = file;
      this.photo.imagename = file.name;
      this.createImage(file);
    },
    onChangeOptions(value, field){
      this.change_options[field] = value;
    },
  },

  async created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'CompanyList' });
    this.imageurl = this.initvalue.companyimage;
    this.images = this.initvalue.companyimages;
    let options = {isSalesTax: false, isDualCurrency: false};
    this.edit_company = Object.assign({}, {options: options}, this.initvalue);

    this.pricelists = await this.getPriceListsByIdRequest(this.initvalue._id);
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
